/**
 * TestFitRerunPanel — thin wrapper around FeasibilityRerunPanel with site-
 * layout-domain gap categorization (Setbacks / Topography / Stormwater /
 * Zoning). Workflow Prompt 6.
 */
import React from 'react';
import { FeasibilityRerunPanel, type RerunPanelProps, type DataGapItem } from './FeasibilityRerunPanel';
import { getGapCategoriesForType } from '../../../lib/rerunGapCategories';

export function TestFitRerunPanel(props: RerunPanelProps) {
  return (
    <FeasibilityRerunPanel
      {...props}
      gapCategorizer={(gaps: DataGapItem[]) => getGapCategoriesForType('test-fit', gaps)}
    />
  );
}
